import { __decorate, __metadata } from "tslib";
/* tslint:disable */
/* auto-generated angular directive proxies */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, NgZone } from '@angular/core';
import { ProxyCmp, proxyOutputs } from './angular-component-lib/utils';
import * as i0 from "@angular/core";
const _c0 = ["*"];
let MriAccordion = class MriAccordion {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriAccordion.ɵfac = function MriAccordion_Factory(t) {
  return new (t || MriAccordion)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriAccordion.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriAccordion,
  selectors: [["mri-accordion"]],
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriAccordion_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriAccordion = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriAccordion);
export { MriAccordion };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriAccordionSection = class MriAccordionSection {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriAccordionSection.ɵfac = function MriAccordionSection_Factory(t) {
  return new (t || MriAccordionSection)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriAccordionSection.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriAccordionSection,
  selectors: [["mri-accordion-section"]],
  inputs: {
    closed: "closed",
    counter: "counter",
    header: "header",
    status: "status"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriAccordionSection_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriAccordionSection = __decorate([ProxyCmp({
  inputs: ['closed', 'counter', 'header', 'status']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriAccordionSection);
export { MriAccordionSection };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriButton = class MriButton {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriButton.ɵfac = function MriButton_Factory(t) {
  return new (t || MriButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriButton.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriButton,
  selectors: [["mri-button"]],
  inputs: {
    buttonWidth: "buttonWidth",
    colorScheme: "colorScheme",
    disabled: "disabled",
    icon: "icon",
    iconLocation: "iconLocation",
    label: "label",
    size: "size",
    state: "state",
    variant: "variant"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriButton_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriButton = __decorate([ProxyCmp({
  inputs: ['buttonWidth', 'colorScheme', 'disabled', 'icon', 'iconLocation', 'label', 'size', 'state', 'variant']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriButton);
export { MriButton };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriCounter = class MriCounter {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriCounter.ɵfac = function MriCounter_Factory(t) {
  return new (t || MriCounter)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriCounter.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriCounter,
  selectors: [["mri-counter"]],
  inputs: {
    status: "status",
    value: "value"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriCounter_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriCounter = __decorate([ProxyCmp({
  inputs: ['status', 'value']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriCounter);
export { MriCounter };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriDrawer = class MriDrawer {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['beforeNavigateBack', 'afterDrawerClose']);
  }
};
/** @nocollapse */
MriDrawer.ɵfac = function MriDrawer_Factory(t) {
  return new (t || MriDrawer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriDrawer.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriDrawer,
  selectors: [["mri-drawer"]],
  inputs: {
    heading: "heading",
    icon: "icon",
    loading: "loading",
    opened: "opened",
    showBackButton: "showBackButton",
    size: "size"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriDrawer_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriDrawer = __decorate([ProxyCmp({
  inputs: ['heading', 'icon', 'loading', 'opened', 'showBackButton', 'size'],
  methods: ['close', 'open']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriDrawer);
export { MriDrawer };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriFlyout = class MriFlyout {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['afterFlyoutClose', 'afterFlyoutOpen']);
  }
};
/** @nocollapse */
MriFlyout.ɵfac = function MriFlyout_Factory(t) {
  return new (t || MriFlyout)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriFlyout.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriFlyout,
  selectors: [["mri-flyout"]],
  inputs: {
    dismissable: "dismissable",
    dontTrapFocus: "dontTrapFocus",
    fillContainer: "fillContainer",
    opened: "opened",
    side: "side",
    size: "size"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriFlyout_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriFlyout = __decorate([ProxyCmp({
  inputs: ['dismissable', 'dontTrapFocus', 'fillContainer', 'opened', 'side', 'size'],
  methods: ['close', 'open']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriFlyout);
export { MriFlyout };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriHider = class MriHider {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriHider.ɵfac = function MriHider_Factory(t) {
  return new (t || MriHider)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriHider.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriHider,
  selectors: [["mri-hider"]],
  inputs: {
    closed: "closed",
    closedLabel: "closedLabel",
    hiderPosition: "hiderPosition",
    labelPosition: "labelPosition",
    openedLabel: "openedLabel"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriHider_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriHider = __decorate([ProxyCmp({
  inputs: ['closed', 'closedLabel', 'hiderPosition', 'labelPosition', 'openedLabel']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriHider);
export { MriHider };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriHotkey = class MriHotkey {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriHotkey.ɵfac = function MriHotkey_Factory(t) {
  return new (t || MriHotkey)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriHotkey.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriHotkey,
  selectors: [["mri-hotkey"]],
  inputs: {
    alt: "alt",
    control: "control",
    keyName: "keyName",
    shift: "shift"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriHotkey_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriHotkey = __decorate([ProxyCmp({
  inputs: ['alt', 'control', 'keyName', 'shift']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriHotkey);
export { MriHotkey };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriIcon = class MriIcon {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriIcon.ɵfac = function MriIcon_Factory(t) {
  return new (t || MriIcon)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriIcon.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriIcon,
  selectors: [["mri-icon"]],
  inputs: {
    icon: "icon",
    size: "size"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriIcon_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriIcon = __decorate([ProxyCmp({
  inputs: ['icon', 'size']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriIcon);
export { MriIcon };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriIconButton = class MriIconButton {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriIconButton.ɵfac = function MriIconButton_Factory(t) {
  return new (t || MriIconButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriIconButton.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriIconButton,
  selectors: [["mri-icon-button"]],
  inputs: {
    colorScheme: "colorScheme",
    disabled: "disabled",
    icon: "icon",
    label: "label",
    size: "size",
    state: "state"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriIconButton_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriIconButton = __decorate([ProxyCmp({
  inputs: ['colorScheme', 'disabled', 'icon', 'label', 'size', 'state']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriIconButton);
export { MriIconButton };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriNavigationBar = class MriNavigationBar {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriNavigationBar.ɵfac = function MriNavigationBar_Factory(t) {
  return new (t || MriNavigationBar)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriNavigationBar.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriNavigationBar,
  selectors: [["mri-navigation-bar"]],
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriNavigationBar_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriNavigationBar = __decorate([ProxyCmp({
  methods: ['hideMenuOverlay', 'showMenuOverlay']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriNavigationBar);
export { MriNavigationBar };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriNavigationBarWrapper = class MriNavigationBarWrapper {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriNavigationBarWrapper.ɵfac = function MriNavigationBarWrapper_Factory(t) {
  return new (t || MriNavigationBarWrapper)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriNavigationBarWrapper.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriNavigationBarWrapper,
  selectors: [["mri-navigation-bar-wrapper"]],
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriNavigationBarWrapper_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriNavigationBarWrapper = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriNavigationBarWrapper);
export { MriNavigationBarWrapper };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriNavigationButton = class MriNavigationButton {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriNavigationButton.ɵfac = function MriNavigationButton_Factory(t) {
  return new (t || MriNavigationButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriNavigationButton.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriNavigationButton,
  selectors: [["mri-navigation-button"]],
  inputs: {
    flixVideoAvailable: "flixVideoAvailable",
    icon: "icon",
    link: "link"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriNavigationButton_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriNavigationButton = __decorate([ProxyCmp({
  inputs: ['flixVideoAvailable', 'icon', 'link']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriNavigationButton);
export { MriNavigationButton };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriNavigationButtonIcon = class MriNavigationButtonIcon {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriNavigationButtonIcon.ɵfac = function MriNavigationButtonIcon_Factory(t) {
  return new (t || MriNavigationButtonIcon)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriNavigationButtonIcon.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriNavigationButtonIcon,
  selectors: [["mri-navigation-button-icon"]],
  inputs: {
    flixVideoAvailable: "flixVideoAvailable",
    icon: "icon"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriNavigationButtonIcon_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriNavigationButtonIcon = __decorate([ProxyCmp({
  inputs: ['flixVideoAvailable', 'icon']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriNavigationButtonIcon);
export { MriNavigationButtonIcon };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriNavigationButtonMenu = class MriNavigationButtonMenu {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriNavigationButtonMenu.ɵfac = function MriNavigationButtonMenu_Factory(t) {
  return new (t || MriNavigationButtonMenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriNavigationButtonMenu.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriNavigationButtonMenu,
  selectors: [["mri-navigation-button-menu"]],
  inputs: {
    flixVideoAvailable: "flixVideoAvailable",
    heading: "heading",
    icon: "icon"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriNavigationButtonMenu_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriNavigationButtonMenu = __decorate([ProxyCmp({
  inputs: ['flixVideoAvailable', 'heading', 'icon'],
  methods: ['hideMenuElement', 'showMenuElement', 'showMenuElementOnly']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriNavigationButtonMenu);
export { MriNavigationButtonMenu };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriNavigationMenuGroup = class MriNavigationMenuGroup {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriNavigationMenuGroup.ɵfac = function MriNavigationMenuGroup_Factory(t) {
  return new (t || MriNavigationMenuGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriNavigationMenuGroup.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriNavigationMenuGroup,
  selectors: [["mri-navigation-menu-group"]],
  inputs: {
    heading: "heading"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriNavigationMenuGroup_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriNavigationMenuGroup = __decorate([ProxyCmp({
  inputs: ['heading'],
  methods: ['getMenuItems']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriNavigationMenuGroup);
export { MriNavigationMenuGroup };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriNavigationMenuItem = class MriNavigationMenuItem {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriNavigationMenuItem.ɵfac = function MriNavigationMenuItem_Factory(t) {
  return new (t || MriNavigationMenuItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriNavigationMenuItem.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriNavigationMenuItem,
  selectors: [["mri-navigation-menu-item"]],
  inputs: {
    label: "label",
    link: "link"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriNavigationMenuItem_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriNavigationMenuItem = __decorate([ProxyCmp({
  inputs: ['label', 'link'],
  methods: ['getLinkElement']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriNavigationMenuItem);
export { MriNavigationMenuItem };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriOverlay = class MriOverlay {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['afterOverlayClose']);
  }
};
/** @nocollapse */
MriOverlay.ɵfac = function MriOverlay_Factory(t) {
  return new (t || MriOverlay)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriOverlay.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriOverlay,
  selectors: [["mri-overlay"]],
  inputs: {
    dismissable: "dismissable",
    opened: "opened"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriOverlay_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriOverlay = __decorate([ProxyCmp({
  inputs: ['dismissable', 'opened']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriOverlay);
export { MriOverlay };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriSpinner = class MriSpinner {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriSpinner.ɵfac = function MriSpinner_Factory(t) {
  return new (t || MriSpinner)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriSpinner.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriSpinner,
  selectors: [["mri-spinner"]],
  inputs: {
    colorScheme: "colorScheme",
    size: "size"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriSpinner_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriSpinner = __decorate([ProxyCmp({
  inputs: ['colorScheme', 'size']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriSpinner);
export { MriSpinner };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriSplitButton = class MriSplitButton {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriSplitButton.ɵfac = function MriSplitButton_Factory(t) {
  return new (t || MriSplitButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriSplitButton.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriSplitButton,
  selectors: [["mri-split-button"]],
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriSplitButton_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriSplitButton = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriSplitButton);
export { MriSplitButton };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriSuccessStamp = class MriSuccessStamp {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
  }
};
/** @nocollapse */
MriSuccessStamp.ɵfac = function MriSuccessStamp_Factory(t) {
  return new (t || MriSuccessStamp)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriSuccessStamp.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriSuccessStamp,
  selectors: [["mri-success-stamp"]],
  inputs: {
    autoRun: "autoRun",
    confetti: "confetti"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriSuccessStamp_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriSuccessStamp = __decorate([ProxyCmp({
  inputs: ['autoRun', 'confetti'],
  methods: ['yay']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriSuccessStamp);
export { MriSuccessStamp };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MriSwitch = class MriSwitch {
  constructor(c, r, z) {
    this.z = z;
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['change']);
  }
};
/** @nocollapse */
MriSwitch.ɵfac = function MriSwitch_Factory(t) {
  return new (t || MriSwitch)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
};
/** @nocollapse */
MriSwitch.ɵcmp = /** @pureOrBreakMyCode */i0.ɵɵdefineComponent({
  type: MriSwitch,
  selectors: [["mri-switch"]],
  inputs: {
    colorScheme: "colorScheme",
    disabled: "disabled",
    offLabel: "offLabel",
    onLabel: "onLabel",
    value: "value"
  },
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function MriSwitch_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2,
  changeDetection: 0
});
MriSwitch = __decorate([ProxyCmp({
  inputs: ['colorScheme', 'disabled', 'offLabel', 'onLabel', 'value']
}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], MriSwitch);
export { MriSwitch };
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
